<style>
    .table-dashboard thead tr td {
        background: #1f2248;
        color: #fff;
    }
    </style>
    <template>
        <zen-one
            :showuserinfo="false"
            title="Sistem Hasil Bersepadu Kedah (iHasil)"
            :crumbs="crumbs"
        >
            <z-page title=" Laporan Prestasi Bagi Kutipan Keseluruhan Koding">
                <w-form ref="dform" @validate="search">
                    <w-flex class="mt3">
                        <div class="xs6 mr3">
                            <w-input
                                v-model="cari.tarikh_hingga"
                                required
                                label="Hingga"
                                type="date"
                            />
                            <z-lookup
                                label="Jabatan"
                                :url="service_kutipan + 'lookup/jabatan_prestasi'"
                                :sort="false"
                                :cache="false"
                                v-model="cari.jabatan_id"
                            />
                        </div>
                        <div class="xs6 mr3">
                            
                        </div>
                    </w-flex>
                </w-form>
    
                <w-flex class="mt1 mb3" justify-end>
                    <div class="mt2 text-right">
                        <w-button
                            class="ml1"
                            v-on:click="reset()"
                            bg-color="warning"
                        >
                            <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                        </w-button>
                        <w-button class="ml1" @click="$refs.dform.validate()">
                            <w-icon>fal fa-search</w-icon>&nbsp;Cari
                        </w-button>
                    </div>
                </w-flex>

                <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
                <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                    <table class="table-dashboard" width="100%" >
                        <thead>
                            <tr>
                                <td>BIL.</td>
                                <td>KOD AKAUN</td>
                                <td>PERIHAL</td>
                                <td>ANGGARAN (RM)</td>
                                <td>PATUT KUTIP (RM)</td>
                                <td v-for="(hd, index) in table.headers" colspan="3">{{ hd.keterangan }}</td>
                                <td>KESELURUHAN (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- <template v-if="(table.hasil_items) || (table.liabiliti_items)"> -->
                                <tr>
                                    <td :colspan="table.headers.length+6"><b>HASIL</b></td>
                                </tr>
                                <tr>
                                    <td :colspan="5"><b></b></td>
                                    <template v-for="(hd, index) in table.headers">
                                        <td><b>KUTIPAN (RM)</b></td>
                                        <td><b>PELARASAN (RM)</b></td>
                                        <td><b>JUMLAH (RM)</b></td>
                                    </template>
                                    <td></td>
                                </tr>
                                <tr v-for="(dt, index) in table.hasil_items">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ dt.kod }}</td>
                                    <td>{{ dt.perihal }}</td>
                                    <td style="text-align:right;">{{ dt.anggaran }}</td>
                                    <td style="text-align:right;">{{ dt.patut_kutip }}</td>
                                    <template v-for="(jab, id) in table.headers">
                                        <td style="text-align:right;">{{ dt[jab.kutipan_name] }}</td>
                                        <td style="text-align:right;">{{ dt[jab.pelarasan_name] }}</td>
                                        <td style="text-align:right;">{{ dt[jab.jumlah_name] }}</td>
                                    </template>
                                    <td style="text-align:right;">{{ dt.keseluruhan }}</td>
                                </tr>
                                <tr>
                                    <td :colspan="3"><b>JUMLAH</b></td>
                                    <td style="text-align:right;"><b>{{table.jml_anggaran_hasil}}</b></td>
                                    <td style="text-align:right;"><b>{{table.jml_patut_kutip_hasil}}</b></td>
                                    <template v-for="(jab, index) in table.headers">
                                        <td v-if="table.jml_jabatan_hasil" style="text-align:right;"><b>{{table.jml_jabatan_hasil[jab.kutipan_name]}}</b></td>
                                        <td v-if="table.jml_jabatan_hasil" style="text-align:right;"><b>{{table.jml_jabatan_hasil[jab.pelarasan_name]}}</b></td>
                                        <td v-if="table.jml_jabatan_hasil" style="text-align:right;"><b>{{table.jml_jabatan_hasil[jab.jumlah_name]}}</b></td>
                                    </template>
                                    <td style="text-align:right;"><b>{{table.jml_keseluruhan_hasil}}</b></td>
                                </tr>

                                <tr>
                                    <td :colspan="table.headers.length+6"><b>LIABILITI</b></td>
                                </tr>
                                <tr>
                                    <td :colspan="5"><b></b></td>
                                    <template v-for="(hd, index) in table.headers">
                                        <td><b>KUTIPAN (RM)</b></td>
                                        <td><b>PELARASAN (RM)</b></td>
                                        <td><b>JUMLAH (RM)</b></td>
                                    </template>
                                    <td></td>
                                </tr>
                                <tr v-for="(dt, index) in table.liabiliti_items">
                                    <td>{{ index+1 }}</td>
                                    <td>{{ dt.kod }}</td>
                                    <td>{{ dt.perihal }}</td>
                                    <td style="text-align:right;">{{ dt.anggaran }}</td>
                                    <td style="text-align:right;">{{ dt.patut_kutip }}</td>
                                    <template v-for="(jab, id) in table.headers">
                                        <td style="text-align:right;">{{ dt[jab.kutipan_name] }}</td>
                                        <td style="text-align:right;">{{ dt[jab.pelarasan_name] }}</td>
                                        <td style="text-align:right;">{{ dt[jab.jumlah_name] }}</td>
                                    </template>
                                    <td style="text-align:right;">{{ dt.keseluruhan }}</td>
                                </tr>
                                <tr>
                                    <td :colspan="3"><b>JUMLAH</b></td>
                                    <td style="text-align:right;"><b>{{table.jml_anggaran_liabiliti}}</b></td>
                                    <td style="text-align:right;"><b>{{table.jml_patut_kutip_liabiliti}}</b></td>
                                    <template v-for="(jab, index) in table.headers">
                                        <td v-if="table.jml_jabatan_liabiliti" style="text-align:right;"><b>{{table.jml_jabatan_liabiliti[jab.kutipan_name]}}</b></td>
                                        <td v-if="table.jml_jabatan_liabiliti" style="text-align:right;"><b>{{table.jml_jabatan_liabiliti[jab.pelarasan_name]}}</b></td>
                                        <td v-if="table.jml_jabatan_liabiliti" style="text-align:right;"><b>{{table.jml_jabatan_liabiliti[jab.jumlah_name]}}</b></td>
                                    </template>
                                    <td style="text-align:right;"><b>{{table.jml_keseluruhan_liabiliti}}</b></td>
                                </tr>
                                <tr>
                                    <td :colspan="3"><b>JUMLAH KESELURUHAN</b></td>
                                    <td style="text-align:right;"><b>{{table.jml_anggaran_keseluruhan}}</b></td>
                                    <td style="text-align:right;"><b>{{table.jml_patut_kutip_keseluruhan}}</b></td>
                                    <template v-for="(jab, index) in table.headers">
                                        <td v-if="table.jml_jabatan_keseluruhan" style="text-align:right;"><b>{{table.jml_jabatan_keseluruhan[jab.kutipan_name]}}</b></td>
                                        <td v-if="table.jml_jabatan_keseluruhan" style="text-align:right;"><b>{{table.jml_jabatan_keseluruhan[jab.pelarasan_name]}}</b></td>
                                        <td v-if="table.jml_jabatan_keseluruhan" style="text-align:right;"><b>{{table.jml_jabatan_keseluruhan[jab.jumlah_name]}}</b></td>
                                    </template>
                                    <td style="text-align:right;"><b>{{table.jml_keseluruhan_keseluruhan}}</b></td>
                                </tr>
                        <!-- </template>
                        <template v-else>
                            <tr>
                                <td colspan="7" style="text-align: center">Tiada Rekod</td>
                            </tr>
                        </template> -->
                        </tbody>
                    </table>
                </div>
            </w-flex>
    
                <w-flex class="mt1 mb3" justify-center>
                    <div class="mt2 text-center">
                        <w-button bg-color="success" class="mr3" @click="cetak()">
                            <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                        </w-button>
                        <w-button bg-color="info" class="mr3" @click="excel()">
                            <w-icon>fal fa-file-excel</w-icon>&nbsp;Excel
                        </w-button>
                    </div>
                </w-flex>
            </z-page>
        </zen-one>
    </template>
    
<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/dummy",
            reload: true,
            loading: false,
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/kutipan_keseluruhan_koding" },
                { label: "Laporan", route: "/kutipan/laporan/kutipan_keseluruhan_koding" },
                {
                    label: "Laporan Prestasi Bagi Kutipan Keseluruhan Koding",
                    route: "/kutipan/laporan/kutipan_keseluruhan_koding",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", akaun_id: "", jabatan_id: "" },
        };
    },
    methods: {
        search() {
            this.getQueryData();
        },
        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", akaun_id: "", jabatan_id: "" };
            this.search();
        },

        cetak() {
            window.open(this.service_laporan+'kutipan/laporan/kutipan_keseluruhan_koding?cetak=1&user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga +
            "&jabatan_id=" + this.cari.jabatan_id +
            "&akaun_id=" + this.cari.akaun_id,'_blank');
            },
        excel() {
            window.open(this.service_laporan+'kutipan/laporan/kutipan_keseluruhan_koding?cetak=1&user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga +
            "&jabatan_id=" + this.cari.jabatan_id +
            "&akaun_id=" + this.cari.akaun_id +
            "&xls=1",'_blank');
            },
        async getQueryData() {
            this.loading = true;
            const resp = await axios.get(
                this.service_laporan + "kutipan/laporan/kutipan_keseluruhan_koding?user_id=" + this.auth.user.id +
                    "&tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&jabatan_id=" + this.cari.jabatan_id +
                    "&akaun_id=" + this.cari.akaun_id
            );
            this.table = resp.data;
            this.loading = false;
        },
    },
    watch: {},
    mounted() {
        // override default setting
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.akaun_id == "undefined") {
            this.cari.akaun_id = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
    